.trigger {
  display: inline-grid;
  place-items: center;
  width: var(--target-min);
  height: var(--target-min);
  border: var(--border-default) solid var(--color-border-default);
  border-radius: var(--radius-control);
  background: transparent;
  color: var(--color-content-primary);
  cursor: pointer;
  transition: background-color var(--motion-fast) var(--motion-ease);
}

.mobileTrigger {
  display: none;
}

.trigger[data-hovered],
.trigger[data-pressed] {
  background: var(--color-bg-hover);
}

.popover {
  min-width: 14rem;
  max-height: min(28rem, calc(100dvh - 5rem));
  overflow-y: auto;
  border: var(--border-default) solid var(--color-border-strong);
  border-radius: var(--radius-surface);
  background: var(--color-bg-surface);
  box-shadow: var(--shadow-modal);
  transform-origin: top right;
}

.popover[data-entering] {
  animation: enter var(--motion-standard) var(--motion-ease);
}

.popover[data-placement^='top'] {
  transform-origin: bottom right;
}

@keyframes enter {
  from {
    opacity: 0;
    transform: translateY(calc(var(--motion-travel) * -0.5));
  }
}

.menu {
  padding: var(--space-2);
  outline: none;
}

.header {
  padding: var(--space-2) var(--space-3) var(--space-1);
  color: var(--color-content-tertiary);
  font: var(--type-label);
  letter-spacing: var(--tracking-label);
}

.item {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-height: var(--target-min);
  padding: 0 var(--space-3);
  border-radius: var(--radius-control);
  color: var(--color-content-primary);
  font: var(--type-compact);
  cursor: pointer;
  outline: none;
}

.item[data-focused] {
  background: var(--color-bg-hover);
}

.item[data-focus-visible] {
  outline: var(--border-strong) solid var(--color-focus-ring);
  outline-offset: -2px;
}

/* Selection is shown by shape and weight, not color (§3.7). */
.item::before {
  content: '';
  width: 0.5rem;
  height: 0.5rem;
  border: var(--border-default) solid var(--color-border-default);
  border-radius: var(--radius-round);
}

.item[data-selected] {
  font-weight: 600;
}

/* Navigation items are links, not choices. */
.link::before {
  display: none;
}

.item[data-selected]::before {
  border-color: var(--color-content-primary);
  background: var(--color-content-primary);
}

.separator {
  height: var(--border-default);
  margin: var(--space-2) 0;
  background: var(--color-border-subtle);
}

@media (max-width: 767px) {
  .toolbarTrigger {
    display: none;
  }

  .mobileTrigger {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: var(--space-1);
    width: 100%;
    height: auto;
    min-height: var(--target-min);
    padding: var(--space-1) 0;
    border: 0;
    color: var(--color-content-secondary);
    font: var(--type-label);
  }

  .mobileTrigger[data-hovered],
  .mobileTrigger[data-pressed] {
    background: var(--color-bg-hover);
    color: var(--color-content-primary);
  }
}
